import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { FileUploadConfig } from '../type/file-upload-config';
import { isFunction } from '@pct-ts/typeguard';
import { resolveBoolean } from '@pct-ts/common';

@Pipe({
  name: 'showPreview',
})
export class ShowPreviewPipe implements PipeTransform {
  transform(config: FileUploadConfig, file: File, defaultValue = true): boolean {
    if (isFunction(config?.showPreview)) {
      return resolveBoolean(config.showPreview, file);
    }
    return config?.showPreview ?? defaultValue;
  }
}
